<!-- show.wxml -->
<template>
    <div class="container">
        <!-- banner -->
        <div class="banner">
            <nut-swiper
                direction="horizontal"
                :loop="true"
                :canDragging="false"
                :paginationVisible="true"
                :swiperData="goods.image"
            >
                <div v-for="(item,index) in goods.image" :key="index" class="nut-swiper-slide">
                    <div class="image">
                        <img :src="item.file_path" width="100%" height="100%"/>
                    </div>
                </div>
            </nut-swiper>
        </div>
        <!-- banner end -->
        <div class="goods-name">
            {{goods.goods_name}}

        </div>
        <div class="price-box clearfix">
            <div class="price">${{seckill_price}}
                <span style="color: #333;font-size: 16px;">/{{goods.salesunit}} {{goods.skunum}}{{goods.skuunit}}</span>
            </div>
            <div class="mark-price">${{original_price}}</div>
        </div>
        <div class="data-box clearfix">
            <div class="stock">已抢：{{active.sales_actual}}</div>
            <div class="volume">剩余：{{seckill_stock}}</div>
        </div>
        <div class="divider-line"></div>
        <div class="param-item">
            <span style="color:#323232;">剩余时间:</span>
            <div class="text" style="margin-left: 20px;color: #ff5656">
                <nut-countdown
                    :end-time="actEndTimeList[0].date"
                    :on-end="endSeckill"
                >
                </nut-countdown>
            </div>
        </div>
        <div class="divider-line"></div>
        <!-- 商品详情 -->
        <div class="show-content" style="border-top: 1px solid #eee">
            <div class="title-box">
                <div class="title" style="font-size: 14px">商品详情</div>
            </div>
            <div class="content" v-html="goods.content">
            </div>
        </div>
        <div class="bottom-aside">
            <router-link to="/" class="to-index">
                <div class="iconfont icon-shouye1"></div>
                <div class="text">首页</div>
            </router-link>
            <button open-type="contact" class="contact">
                <div class="iconfont icon-kefu1"></div>
                <div class="text">客服</div>
            </button>
            <div class="buy-btn-box">
                <div class="go-buy" @click="showAddCart('buyNow')">
                    <div class="text">立即购买</div>
                </div>
            </div>
        </div>
        <!-- 规格选择 -->
        <nut-popup position="bottom" closeable close-icon="cross" v-model="isShowSku" :style="{height:'50%'}"
                   close-icon-position="top-right">
            <div class="goods-sku-aside">
                <div class="sku-content">
                    <div slot="list" class="sku-form">
                        <div class="goods-detail clearfix">
                            <div class="image-box">
                                <img :src="skuCoverImage" class="skeleton-rect" width="80%">
                            </div>
                            <div class="content-box">
                                <div class="title text-flow skeleton-rect">{{goods.goods_name}}</div>
                                <div class="price-box skeleton-rect">
                                    <div class="price">${{seckill_price}}</div>
                                    <div class="mark-price">${{original_price}}</div>
                                </div>
                                <div class="volume-box skeleton-rect">
                                    <div class="volume">已抢：{{active.sales_actual}}</div>
                                    <div class="stock">剩余：{{seckill_stock}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="sku-list-box">
                            <div class="sku-list clearfix" v-for="(item,index) in goods_sku" :key="index">
                                <div class="group-name">{{item.group_name}}</div>
                                <div class="item-list" v-for="(sku,skuindex) in item.item_list" :key="skuindex">
                                    <input type="radio" :id="item.group_dirname + sku.sku_id" :value="sku.sku_id"
                                           v-model="param[item.group_dirname]"/>
                                    <label :for="item.group_dirname + sku.sku_id"
                                           :class="[sku.sku_id == param[item.group_dirname] ? 'radio-active' : '']">
                                        <div class="sku-img" v-if="sku.sku_image">
                                            <img :src="sku.sku_image" mode="widthFix"/>
                                        </div>
                                        <div class="text">{{sku.sku_name}}</div>
                                    </label>
                                </div>
                            </div>
                            <div class="goods-num-box clearfix">
                                <div class="num-name">数量</div>
                                <div class="num-box">
                                    <div class="add-num iconfont icon-plus-bold" @click="goodsAddNum"></div>
                                    <div class="num-input">
                                        <input type="number" name="goods_num" :value="goods_num" disabled/>
                                    </div>
                                    <div class="remove-num iconfont icon-minus-bold" @click="goodsReomoveNum"></div>
                                </div>
                            </div>
                            <button class="submit-add" @click="onConfirmSubmit">确定</button>
                        </div>
                    </div>
                </div>
            </div>
        </nut-popup>
    </div>
</template>
<script>
    const util = require('../../utils/util.js');
    import Tabber from '@/components/Tabber.vue'
    import ActiveStatusEnum from '../../utils/enum/sharp/GoodsStatus.js';
    // 记录规格的数组
    export default {
        name: 'GoodsSeckill',
        components: {
            Tabber,
            ActiveStatusEnum,
        },
        data() { //默认数据
            return {
                showShareRules: false, //分享规则显示
                buyType: '',
                isPosterCreat: false,
                detail: {},
                goods_sku: [],
                ActiveStatusEnum, // 秒杀活动商品状态
                actEndTimeList: [],
                goods_num: 1, //购买数量
                goods: {},
                goods_sku_id: 0, // 规格id
                original_price: 0,
                seckill_price: 0,
                seckill_stock: 0,
                skuCoverImage: '',
                cart_total_num: 0, // 购物车商品总数量
                isShowParam: false, //是否隐藏参数
                isShowSku: false, //是否隐藏规格
                active_time_id: 0,
                sharp_goods_id: 0,
                goodsMultiSpec: {}, // 多规格信息
                active: {}, // 秒杀活动详情
                shareRulesText: `<div>平台将会为每一次分享，增送对应比例的积分，活动期限长期。</div>
                            <div>积分获得方式：</div>
                            <div>点击分享将产品成功分享给好友，好友产生购买后，按照一定的比例返还积分。（仅当次购买有效）</div>
                            <div>积分用途：</div>
                            <div>积分用于消费时进行现金抵扣。以及后续活动参与抵扣。</div>`,
            }
        },
        created() { //视图加载前执行
            let _this = this;
            _this.sharp_goods_id = _this.$route.query.sharp_goods_id;
            _this.active_time_id = _this.$route.query.active_time_id;
            this.loading = this.$toast.loading('Loading...', {
                coverColor: "rgba(0,0,0,0.5)",
            });
        },
        mounted() { //视图加载完成执行
            let _this = this;
            // 获取秒杀商品信息
            _this.getActiveDetail();
        },
        methods: {

            /**
             * 获取秒杀商品信息
             */
            getActiveDetail() {
                let _this = this;
                _this._get('sharp.goods/detail', {
                    active_time_id: _this.active_time_id,
                    sharp_goods_id: _this.sharp_goods_id,
                }, (result) => {
                    // 初始化详情数据
                    let data = _this._initData(result.data);
                    _this.setData(data);
                    _this.loading.hide();
                });
            },


            /**
             * 初始化详情数据
             */
            _initData(data) {
                let _this = this;
                // 商品详情
                let goodsDetail = data.goods;
                // 商品价格/划线价/库存
                data.goods_sku_id = goodsDetail.goods_sku.spec_sku_id;
                data.seckill_price = goodsDetail.goods_sku.seckill_price;
                data.original_price = goodsDetail.goods_sku.original_price;
                data.seckill_stock = goodsDetail.goods_sku.seckill_stock;
                // 商品封面图(确认弹窗)
                data.skuCoverImage = goodsDetail.goods_image;
                // 多规格商品封面图(确认弹窗)
                if (goodsDetail.spec_type == 20 && goodsDetail.goods_sku['image']) {
                    data.skuCoverImage = goodsDetail.goods_sku['image']['file_path'];
                }
                // 初始化商品多规格
                if (goodsDetail.spec_type == 20) {
                    data.goodsMultiSpec = _this._initManySpecData(goodsDetail.goods_multi_spec);
                }
                // 记录活动到期时间
                data.actEndTimeList = [{
                    date: data.active.active_status == ActiveStatusEnum.STATE_SOON.value ?
                        data.active.start_time : data.active.end_time
                }];
                return data;
            },
            /**
             * 显示规格弹出
             */
            showAddCart: function (type) {
                let _this = this;
                if (_this.active.active_status == 30) {
                    _this.$toast.fail('活动已结束');
                    return false;
                }
                if (_this.active.active_status == 20) {
                    _this.$toast.warn('活动尚未开始');
                    return false;
                }
                _this.isShowSku = true
                _this.buyType = type
            },
            /**
             * 关闭弹窗
             */
            hiddenGoodsSku: function () {
                this.isShowSku = false
            },

            /**
             * 立即购买
             */
            onConfirmSubmit() {
                let _this = this;
                _this.navigationTo('/flow/checkout',{
                    order_type:'sharp',
                    active_time_id: _this.active_time_id,
                    sharp_goods_id: _this.sharp_goods_id,
                    goods_sku_id: _this.goods_sku_id,
                    goods_num: _this.goods_num,
                })
            },


            /**
             * 单选按钮切换
             */
            radioChange: function (item, sku) {
                let _this = this;
                _this.param[item.group_dirname] = sku.sku_id;
            },
            /**
             * 购买数量加
             */
            goodsAddNum: function () {
                if (this.goods_num < this.goods.limit_num || this.goods.limit_num == 0) {
                    if (this.goods_num < this.seckill_stock) {
                        this.goods_num = ++this.goods_num
                    } else {
                        this.$toast.warn('超出购买最大数量!');
                    }
                } else {
                    this.$toast.warn('超出购买最大数量！');
                }
            },
            /**
             *  购买数量减
             */
            goodsReomoveNum: function () {
                if (this.goods_num > 1) {
                    this.goods_num = --this.goods_num;
                }
            },

            /**
             *  倒计时结束
             */
            endSeckill: function () {
                this.$toast.warn('活动已经结束');
            },
        },
        destroyed() {
            let _this = this;
            //切记页面销毁需要销毁
        }
    }
</script>
<style lang="scss" scoped>
    @import "seckill.scss";
</style>
